import {
  Facebook,
  Instagram,
  LinkedIn,
  LocationOn,
  Mail,
  PhoneIphone,
  Twitter,
  YouTube,
} from "@mui/icons-material";
import { Button, Container, Grid, Stack, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import logo from "../../../images/songjukti_logo.png";

const Footer = () => {
  const navigate = useNavigate();
  const [showMore, setShowMore] = useState(false);
  return (
    <Box sx={{ bgcolor: "black", zIndex: 5 }}>
      <Container>
        <Grid
          container
          rowSpacing={4}
          spacing={{ xs: 0, md: 2 }}
          sx={{ width: "100%", paddingY: "20px" }}
        >
          <Grid item xs={6} md={4} sx={{ order: 0 }}>
            <Stack spacing={2} sx={{ width: "80%" }}>
              <Box
                component="img"
                sx={{
                  //   objectFit: "cover",

                  width: "40px",
                  height: "auto",
                }}
                alt="Songjukti Logo"
                src={logo}
              />
         <Typography variant="p" 
         sx={{ color: "#b7b7b7", fontSize: "10pt", lineHeight: "1.6" }} > 
         Songjukti is Bangladesh’s fastest-growing freelance and service marketplace, connecting 
         clients with verified professionals across diverse industries. Whether you’re looking for graphic
          design, web development, app creation, printing, or marketing solutions — you’ll find trusted 
          local experts ready to deliver quality work. 
          {!showMore && ( 
            <span style={{ color: "#5c5ce7", cursor: "pointer", textTransform: "capitalize", }}
             onClick={() => { setShowMore(true); }} > 
             see more... </span> )} 
             {showMore && ( 
              <span> Songjukti also helps you discover professionals in photography, event management,
                 legal consulting, real estate, admin support, and more. Compare service providers,
                  view transparent pricing, and read verified reviews from clients. Join Songjukti 
                  Voices — our growing community of freelancers, entrepreneurs, designers, developers,
                   and legal experts — and experience smarter, faster collaboration in Bangladesh’s 
                   digital marketplace. 
                   {showMore && 
                   ( <span style={{ color: "#5c5ce7", cursor: "pointer" }} 
                   onClick={() => { setShowMore(false); }} > {" "} 
                   see less... </span> )} </span> )} 
         </Typography>
            </Stack>
          </Grid>
          <Grid item xs={12} md={4} sx={{ order: { xs: 2, md: 1 } }}>
            <Grid container spacing={{ xs: 2, md: 6 }}>
              <Grid item xs={6}>
                <Stack spacing={1.5}>
                  <Typography
                    variant="p"
                    sx={{ color: "#22AB7D", fontSize: "14pt", fontWeight: 600 }}
                  >
                    Important Links
                  </Typography>
                  <Typography
                    variant="p"
                    onClick={() => {
                      navigate("/about");
                    }}
                    sx={{
                      color: "#b7b7b7",
                      fontSize: "10pt",
                      fontWeight: 500,
                      cursor: "pointer",
                      "&:hover": {
                        color: "white",
                      },
                    }}
                  >
                    About Songjukti
                  </Typography>
                  <Typography
                    variant="p"
                    onClick={() => {
                      navigate("/contact");
                    }}
                    sx={{
                      color: "#b7b7b7",
                      fontSize: "10pt",
                      fontWeight: 500,
                      cursor: "pointer",
                      "&:hover": {
                        color: "white",
                      },
                    }}
                  >
                    Contact
                  </Typography>
                  <Typography
                    variant="p"
                    onClick={() => {
                      // navigate("/ghoramidesk");
                      window.open("https://taskone.xyz/");
                    }}
                    sx={{
                      color: "#b7b7b7",
                      fontSize: "10pt",
                      fontWeight: 500,
                      cursor: "pointer",
                      "&:hover": {
                        color: "white",
                      },
                    }}
                  >
                    TaskOne
                  </Typography>
                  <Typography
                    variant="p"
                    onClick={() => {
                      window.open("https://community.songjukti.com/allFaq");
                    }}
                    sx={{
                      color: "#b7b7b7",
                      fontSize: "10pt",
                      fontWeight: 500,
                      cursor: "pointer",
                      "&:hover": {
                        color: "white",
                      },
                    }}
                  >
                    FAQ
                  </Typography>
                  <Typography
                    // /https://community.songjukti.com/forum
                    onClick={() => {
                      window.open("https://community.songjukti.com/solutions");
                    }}
                    variant="p"
                    sx={{
                      color: "#b7b7b7",
                      fontSize: "10pt",
                      fontWeight: 500,
                      cursor: "pointer",
                      "&:hover": {
                        color: "white",
                      },
                    }}
                  >
                    Solutions
                  </Typography>
                  {/* <Typography
                    variant="p"
                    onClick={() => {
                      window.open("https://community.songjukti.com/blog");
                    }}
                    
                    sx={{
                      color: "#b7b7b7",
                      fontSize: "10pt",
                      fontWeight: 500,
                      cursor: "pointer",
                      "&:hover": {
                        color: "white",
                      },
                    }}
                  >
                    Blog
                  </Typography> */}
                  <Typography
                    variant="p"
                    onClick={() => {
                      navigate("/privacypolicy");
                    }}
                    sx={{
                      color: "#b7b7b7",
                      fontSize: "10pt",
                      fontWeight: 500,
                      cursor: "pointer",
                      "&:hover": {
                        color: "white",
                      },
                    }}
                  >
                    Privacy
                  </Typography>

                  <Typography
                    variant="p"
                    onClick={() => {
                      navigate("/terms");
                    }}
                    sx={{
                      color: "#b7b7b7",
                      fontSize: "10pt",
                      fontWeight: 500,
                      cursor: "pointer",
                      "&:hover": {
                        color: "white",
                      },
                    }}
                  >
                    Terms of uses
                  </Typography>
                </Stack>
              </Grid>
              <Grid item xs={6}>
                <Stack spacing={1.5}>
                  <Typography
                    variant="p"
                    sx={{ color: "#22AB7D", fontSize: "14pt", fontWeight: 600 }}
                  >
                    Popular
                  </Typography>
                  {/* <Typography
                    variant="p"
                    onClick={() => {
                      navigate("/wishlist");
                    }}
                    sx={{
                      color: "#b7b7b7",
                      fontSize: "10pt",
                      fontWeight: 500,
                      cursor: "pointer",
                      "&:hover": {
                        color: "white",
                      },
                    }}
                  >
                    আপনার পছন্দের তালিকা
                  </Typography> */}

                  <Typography
                    onClick={() => {
                      window.open("https://community.songjukti.com/allCourse");
                    }}
                    variant="p"
                    sx={{
                      color: "#b7b7b7",
                      fontSize: "10pt",
                      fontWeight: 500,
                      cursor: "pointer",
                      "&:hover": {
                        color: "white",
                      },
                    }}
                  >
                    Tutorial
                  </Typography>

                  <Typography
                    onClick={() => {
                      window.open("https://community.songjukti.com/forum/");
                    }}
                    variant="p"
                    sx={{
                      color: "#b7b7b7",
                      fontSize: "10pt",
                      fontWeight: 500,
                      cursor: "pointer",
                      "&:hover": {
                        color: "white",
                      },
                    }}
                  >
                    Forum
                  </Typography>
                  <Typography
                    // /https://community.songjukti.com/forum
                    onClick={() => {
                      window.open("https://community.songjukti.com/blog");
                    }}
                    variant="p"
                    sx={{
                      color: "#b7b7b7",
                      fontSize: "10pt",
                      fontWeight: 500,
                      cursor: "pointer",
                      "&:hover": {
                        color: "white",
                      },
                    }}
                  >
                    Blog
                  </Typography>
                  <Typography
                    // /https://community.songjukti.com/forum
                    onClick={() => {
                      window.open("https://community.songjukti.com/support");
                    }}
                    variant="p"
                    sx={{
                      color: "#b7b7b7",
                      fontSize: "10pt",
                      fontWeight: 500,
                      cursor: "pointer",
                      "&:hover": {
                        color: "white",
                      },
                    }}
                  >
                    Support
                  </Typography>
                  <Typography
                    // /https://community.songjukti.com/forum
                    onClick={() => {
                      window.open("https://community.songjukti.com/videos");
                    }}
                    variant="p"
                    sx={{
                      color: "#b7b7b7",
                      fontSize: "10pt",
                      fontWeight: 500,
                      cursor: "pointer",
                      "&:hover": {
                        color: "white",
                      },
                    }}
                  >
                    Vlog
                  </Typography>

                  <Typography
                    // /https://community.songjukti.com/forum
                    onClick={() => {
                      window.open("https://community.songjukti.com/community");
                    }}
                    variant="p"
                    sx={{
                      color: "#b7b7b7",
                      fontSize: "10pt",
                      fontWeight: 500,
                      cursor: "pointer",
                      "&:hover": {
                        color: "white",
                      },
                    }}
                  >
                    Community
                  </Typography>

                  <Typography
                    // /https://community.songjukti.com/forum
                    onClick={() => {
                      window.open("https://community.songjukti.com/campaign");
                    }}
                    variant="p"
                    sx={{
                      color: "#b7b7b7",
                      fontSize: "10pt",
                      fontWeight: 500,
                      cursor: "pointer",
                      "&:hover": {
                        color: "white",
                      },
                    }}
                  >
                    Campaign
                  </Typography>
                </Stack>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={6} md={4} sx={{ order: { xs: 1, md: 2 } }}>
            <Grid container spacing={1}>
              <Grid item md={3} xs={0}></Grid>
              <Grid item xs={12} md={9}>
                <Stack spacing={1.5}>
                  <Typography
                    variant="p"
                    sx={{ color: "#22AB7D", fontSize: "14pt", fontWeight: 600 }}
                  >
                    Contacts
                  </Typography>
                  <Stack
                    spacing={0.5}
                    direction={"row"}
                    justifyContent="left"
                    alignItems={"center"}
                  >
                    <LocationOn
                      sx={{
                        color: "#b7b7b7",
                        fontSize: "11pt",
                        cursor: "pointer",
                        "&:hover": {
                          color: "white",
                        },
                      }}
                    />
                    <Typography
                      variant="p"
                      sx={{
                        color: "#b7b7b7",
                        fontSize: "10pt",
                        fontWeight: 500,
                        cursor: "pointer",
                        "&:hover": {
                          color: "white",
                        },
                      }}
                    >
                      Head Office:
                    </Typography>
                  </Stack>
                  <Typography
                    variant="p"
                    sx={{
                      color: "#b7b7b7",
                      fontSize: "10pt",
                      fontWeight: 500,
                      "&:hover": {
                        color: "white",
                      },
                    }}
                  >
                    Navana Mokhles Monarch, room no- 60 (3/1) 2nd floor, 3-b,
                    purana paltan, Dhaka-1000
                  </Typography>
                  <Stack
                    spacing={0.5}
                    direction={"row"}
                    justifyContent="left"
                    alignItems={"center"}
                  >
                    <PhoneIphone
                      sx={{
                        color: "#b7b7b7",
                        fontSize: "11pt",
                        "&:hover": {
                          color: "white",
                        },
                      }}
                    />
                    <Typography
                      variant="p"
                      sx={{
                        color: "#b7b7b7",
                        fontSize: "10pt",
                        fontWeight: 500,
                        "&:hover": {
                          color: "white",
                        },
                      }}
                    >
                      01849-225187
                    </Typography>
                  </Stack>

                  <Stack
                    spacing={1}
                    direction={"row"}
                    justifyContent="left"
                    alignItems={"center"}
                  >
                    <Mail
                      sx={{
                        color: "#b7b7b7",
                        fontSize: "11pt",
                        fontWeight: 500,
                        cursor: "pointer",
                        "&:hover": {
                          color: "white",
                        },
                      }}
                    />
                    <Typography
                      variant="p"
                      sx={{
                        color: "#b7b7b7",
                        fontSize: "10pt",
                        fontWeight: 500,
                        cursor: "pointer",
                        "&:hover": {
                          color: "white",
                        },
                      }}
                    >
                      contact@songjukti.com
                    </Typography>
                  </Stack>
                  <Stack
                    spacing={1}
                    direction={"row"}
                    justifyContent="left"
                    alignItems={"center"}
                  >
                    <Facebook
                      sx={{
                        color: "#b7b7b7",
                        fontSize: "13pt",
                        fontWeight: 500,
                        cursor: "pointer",
                        "&:hover": {
                          color: "white",
                        },
                      }}
                    />
                    <YouTube
                      sx={{
                        color: "#b7b7b7",
                        fontSize: "13pt",
                        fontWeight: 500,
                        cursor: "pointer",
                        "&:hover": {
                          color: "white",
                        },
                      }}
                    />
                    <Instagram
                      sx={{
                        color: "#b7b7b7",
                        fontSize: "13pt",
                        fontWeight: 500,
                        cursor: "pointer",
                        "&:hover": {
                          color: "white",
                        },
                      }}
                    />
                    <Twitter
                      sx={{
                        color: "#b7b7b7",
                        fontSize: "13pt",
                        fontWeight: 500,
                        cursor: "pointer",
                        "&:hover": {
                          color: "white",
                        },
                      }}
                    />
                    <LinkedIn
                      sx={{
                        color: "#b7b7b7",
                        fontSize: "13pt",
                        fontWeight: 500,
                        cursor: "pointer",
                        "&:hover": {
                          color: "white",
                        },
                      }}
                    />
                  </Stack>
                </Stack>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Footer;
